import { Box, Typography } from "@mui/material"
import type { FC } from "react"

import { AssociateProductType } from "../../../types"

import ToggleInactiveButton from "@/components/common/ToggleInactiveButton"

interface ProductSearchInfoProps {
  productCount: number
  productType: AssociateProductType
  showInactive: boolean
  onShowInactiveToggle: () => void
}

export const ProductSearchInfo: FC<ProductSearchInfoProps> = ({
  productCount,
  productType,
  showInactive,
  onShowInactiveToggle,
}) => {
  return (
    <Box className='mb-6 flex justify-between align-middle'>
      <Typography className='mt-2 inline-flex align-middle text-sm leading-6'>
        <Typography className='inline-flex font-semibold text-gray-800'>{productCount} products found</Typography>,
        Select one from the existing
      </Typography>
      {productType === AssociateProductType.Akrochem && (
        <ToggleInactiveButton
          showInactive={showInactive}
          onToggle={onShowInactiveToggle}
          label='Products'
          className='text-sm'
          data-testid='toggle-inactive-products-button'
        />
      )}
    </Box>
  )
}
